module.exports = __webpack_public_path__ + "static/media/video.05c5f598.webm";